import React from 'react'
import {
    createRegisterableComponentWithData,
    Election,
    ElectionDataLoader,
} from '@news-mono/web-common'
import { PartyTotalsComponent } from './PartyTotals'

type PartyTotalsRouteProps = {
    election: Election
    /** This description appears below the "Party Totals" heading and in the sharing component */
    description: string
}
export const PartyTotalsRegistration = createRegisterableComponentWithData(
    'election-party-totals',
    ElectionDataLoader,
    (props: PartyTotalsRouteProps, data, { onEvent }) => {
        return <PartyTotalsComponent data={data} onEvent={onEvent} {...props} />
    },
)
